import { D, isCanonicalInput, toFactor, toMoney } from './decimal.js';
import { MoneyParseError } from './types.js';
/**
 * Erzeugt einen Geldbetrag aus einer Dezimalzeichenkette.
 *
 * `money('1.500')` und `money('1.50')` ergeben beide `'1.50'` — gleicher Betrag,
 * gleiche Darstellung. Mehr als zwei Nachkommastellen bleiben erhalten, solange sie
 * signifikant sind; das Runden auf Cent ist ein eigener, sichtbarer Schritt.
 */
export function money(input) {
    if (!isCanonicalInput(input)) {
        throw new MoneyParseError(`Ungültiger Geldbetrag ${JSON.stringify(input)}. Erwartet wird eine Dezimalzeichenkette ` +
            `wie "1234.56" oder "-7.99": optionales Minus, Ziffern, optional Punkt und Ziffern. ` +
            `Kein Plus, keine Exponentialschreibweise, kein Komma, keine Leerzeichen.`);
    }
    return toMoney(new D(input));
}
/**
 * Erzeugt einen dimensionslosen Faktor: Menge, Anteil, Steuersatz.
 *
 * Wie `money()`, aber ohne Auffüllen auf zwei Nachkommastellen. Eine Stückzahl als
 * `"1.00"` zu schreiben wäre irreführend.
 */
export function factor(input) {
    if (!isCanonicalInput(input)) {
        throw new MoneyParseError(`Ungültiger Faktor ${JSON.stringify(input)}. Erwartet wird eine Dezimalzeichenkette ` +
            `wie "3", "1.19" oder "-0.5": optionales Minus, Ziffern, optional Punkt und Ziffern. ` +
            `Kein Plus, keine Exponentialschreibweise, kein Komma, keine Leerzeichen.`);
    }
    return toFactor(new D(input));
}
/** Der neutrale Betrag. */
export const ZERO = money('0');
/**
 * Nimmt einen Wert aus der Datenbank (oder einer anderen Außenwelt) entgegen.
 *
 * Der Treiber liefert `NUMERIC` je nach Konfiguration als Zeichenkette oder als
 * `number`. Nur die Zeichenkette ist verlustfrei — deshalb ist `number` hier ein
 * Fehler und keine Bequemlichkeit. Wer eine `number` sieht, hat die Spalte oder den
 * Treiber falsch konfiguriert; ein stilles `String(value)` würde den Verlust
 * festschreiben, der bereits eingetreten ist.
 */
export function fromDb(value) {
    if (typeof value !== 'string') {
        throw new MoneyParseError(`Geldbetrag aus der Datenbank muss eine Zeichenkette sein, war aber ${describe(value)}. ` +
            `NUMERIC-Spalten sind als Zeichenkette zu lesen; eine number hat den Betrag bereits ` +
            `durch die binäre Gleitkommadarstellung geschickt und ist nicht mehr vertrauenswürdig.`);
    }
    return money(value);
}
/** Benennt einen unbekannten Wert für die Fehlermeldung, ohne ihn auszugeben. */
function describe(value) {
    if (value === null)
        return 'null';
    if (Array.isArray(value))
        return 'ein Array';
    return `vom Typ ${typeof value}`;
}
//# sourceMappingURL=construct.js.map